import * as React from 'react';
import { useFormik } from 'formik';
import { Constants, Validators } from 'core';
import { Typology, TypologyForm, RequestError } from 'types';
import { useSelector } from 'react-redux';
import { Select } from 'antd';
import styled from 'styled-components';
import { path } from 'ramda';

import { useIntl } from 'common/config/i18n';
import FormError from 'components/molecules/form-error';
import { StyledRepositoryForm, StyledRepositoryFormButtonWrapper } from 'common/styling/mixins';
import Button from 'components/molecules/button';
import Input from 'components/organisms/input';
import { productCodesSelectors } from 'common/config/store';

const Label = styled.div`
  font-size: ${path(['theme', 'font', 'size', 'body'])};
  font-weight: bold;
`;
interface Props {
  onSubmit: (values: TypologyForm) => void;
  typology?: Typology;
  isUpdate?: boolean;
  error?: RequestError;
  status?: 'loading' | 'error' | 'success';
}
const { Option } = Select;

const Form = (props: Props) => {
  const { t } = useIntl();
  const isUpdate = !!props.typology;
  const productCodes = useSelector(productCodesSelectors.productCodesSelector);
  const initialProductCodes = (props.typology && props.typology.productCodes.map((i) => i.id)) || [];
  const initialValues: TypologyForm = {
    productCodes: initialProductCodes,
    name: props.typology && props.typology.name ? props.typology.name : '',
  };
  const formik = useFormik({
    initialValues,
    validate: (values: TypologyForm) => Validators.formTypology(values),
    onSubmit: (values: TypologyForm) => {
      props.onSubmit(values);
    },
  });

  return (
    <StyledRepositoryForm onSubmit={formik.handleSubmit}>
      <div className="formSection">
        <Label>{t('form', 'CHART_TYPOLOGY')}</Label>
        <Select
          mode="multiple"
          value={formik.values.productCodes}
          onChange={(value) => formik.setFieldValue('productCodes', value)}
        >
          {productCodes.map((x) => (
            <Option value={x.id} key={x.id}>
              {x.name}
            </Option>
          ))}
        </Select>
        <FormError formik={formik} fieldName="productCodes" />
      </div>
      <div className="formSection">
        <Input
          upLabel={t('form', 'FORM_TYPOLOGY')}
          name="name"
          onChange={formik.handleChange}
          value={formik.values.name}
          width="100%"
        />
        <FormError formik={formik} fieldName="name" />
      </div>

      <StyledRepositoryFormButtonWrapper>
        <Button
          height="35px"
          width="100%"
          borderRadius="20px"
          disabled={
            !!(formik.errors.productCodes && formik.touched.productCodes) ||
            !!(formik.errors.name && formik.touched.name)
          }
          htmlType="submit"
          loading={props.status === 'loading'}
        >
          {t('Buttons', isUpdate ? 'SAVE_BUTTON' : 'CREATE_BUTTON')}
        </Button>
      </StyledRepositoryFormButtonWrapper>
      {props.error && (
        <FormError
          message={
            props.error === Constants.ALREADY_EXISTED_PROBLEM_CODE
              ? t('form', 'FORM_TYPOLOGY_ALLREADY_EXIST')
              : t('form', 'FORM_UNKNOWN_ERROR')
          }
        />
      )}
    </StyledRepositoryForm>
  );
};
export default Form;
